import EasyPassClient from './EasyPassClient';

class RunListClient {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.easyPassRootUri = 'api/acvapi/v3';
    this.rootUri = 'auctions';
  }

  getList(params) {
    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/run_list`, params);
  }

  getListSince(maxAuctionId, query) {
    const params = {
      since_auction_id: maxAuctionId,
    };

    if (query) {
      params.query = query;
    }

    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/run_list`, params);
  }

  get(auctionId) {
    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/run_list`, { auction_id: auctionId });
  }

  /**
   * This method will eventually replace the `submitBid` method but
   * currently only the logic for submitting a bid to an auction in
   * the `run_list` state is supported.
   *
   * @param {number} auctionId unique idenitfier for the auction
   * @param {number} amount bid amount to be placed
   * @param {number} userId unique identifier for the user
   * @param {boolean} proxy true if this is a proxy bid
   * @param {boolean} persistent true if this is a persistent proxy bid
   */
  submitRunListBid(auctionId, amount, userId, proxy = false, persistent = false) {
    const bidData = {
      auction_id: auctionId,
      amount,
      proxy,
      persistent,
    };
    return this.easyPassClient.post(`${this.easyPassRootUri}/auction/${auctionId}/bid`, bidData);
  }
}

export default RunListClient;
